module.exports = __webpack_public_path__ + "static/AvenirNext-Italic-97714b22a1cd20d4d56687d997832359.woff";